// 永続化するキーのリスト

// wabunka
export const CALENDAR_LIST = 'calendarList';
export const SEARCH_EXPERIENCES_MODAL_TAB_INDEX = 'searchExperiencesModalTabIndex';
export const SEARCH_EXPERIENCES_MODAL = 'searchExperiencesModal';
export const EXPERIENCE_DETAIL_IMAGE_MODAL = 'experienceDetailImageModal';
export const EXPERIENCE_GALLERY_MODAL = 'experienceGalleryModal';

export const PERSIST_KEY_LIST = [CALENDAR_LIST, SEARCH_EXPERIENCES_MODAL_TAB_INDEX, SEARCH_EXPERIENCES_MODAL] as const;

export type PERSIST_KEY = (typeof PERSIST_KEY_LIST)[number];

export const stateFactory = {
  /**
   * Cypress でモックが可能なようにオブジェクト形式にしている
   * 与えられたキーで Global State を初期化する
   * 既に同じキーで State が存在する場合は何もしない
   * @param key state のキーです
   * @param defaultValue state の初期値です
   */
  create: <T>(key: string, defaultValue: T) => {
    const state = useState<T>(key);

    // 既に State が作成されている場合は上書きしない
    if (state.value) return state;

    // State 未作成の場合は新しい State を作成して返却する
    return useState<T>(key, () => defaultValue);
  },
};
